export const typeCosts = [
  { id: 0, name: "average-cost" },
  { id: 1, name: "last-purchase-price" },
  { id: 2, name: "last-supply-price" },
  { id: 3, name: "item-purchase-price" },
];

export const typeQties = [
  { id: 0, name: "all" },
  { id: 1, name: "items_except_negative" },
  { id: 2, name: "items_except_zero" },
  { id: 3, name: "items_except_negative_and_zero" },
  { id: 4, name: "negative-items-only" },
  { id: 5, name: "zero-items-only" },
  { id: 6, name: "negative-and-zero-items-only" },
];
export const defaultGRDparms = {
  typeCost: typeCosts[0],
  safe: { id: -1, name: "all" },
  typeQtys: typeQties[0],
  isStore: true,
  isFactory: false,
  isRaw: false,
};
